var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component, Suspense } from 'react';

import Footer from "../../App/Footer";
import MarkdownViewer from "../../Markdown";
import { Context } from "../../Markdown/components";
import { ErrorBoundary } from "../../App/ErrorHandling/ErrorBoundary";
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { ErrorFallback } from "../../App/ErrorHandling/ErrorFallback";
import { parseRenderingError } from "../../App/ErrorHandling/ErrorUtils";
import { NeedAuthorization } from "../../Auth";
import Script from "./Script";

const parseSSRError = (error) => {
  const SSRError = error instanceof Immutable.Map ? error.toJS() : error;
  return SSRError !== null && SSRError !== void 0 && SSRError.json ? parseRenderingError(SSRError) : null;
};

class PageViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.warningPageError = this.warningPageError.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.page.get('title') !== this.props.page.get('title')) {
      this.removeCustomPageError();
    }
  }

  componentWillUnmount() {
    if (this.state.customPageError) {
      this.removeCustomPageError();
    }
  }

  warningPageError(error) {
    this.setState({ customPageError: error });
  }

  removeCustomPageError() {
    this.setState({ customPageError: null });
  }

  renderErrorWarning() {
    return /*#__PURE__*/(
      _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
      _jsx("div", { className: "alert alert-danger" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), /*#__PURE__*/
      _jsx(Translate, { translationKey: "custom page error warning" }, void 0, "There is an unexpected error on this custom page, it may not work properly. Please contact an admin for details."


      ), /*#__PURE__*/
      _jsx(Icon, { icon: "times", onClick: () => this.removeCustomPageError() })
      )
      ));

  }

  render() {
    const { page, itemLists, datasets, error, setBrowserTitle } = this.props;
    const lists = itemLists.toJS();
    const originalText = page.getIn(['metadata', 'content']) || '';
    const scriptRendered = page.getIn(['scriptRendered']);
    let scriptCode = page.getIn(['metadata', 'script']) || '';
    scriptCode = `var datasets = window.store.getState().page.datasets.toJS();
    ${scriptCode}`;
    const parsedPageError = parseSSRError(error);

    return /*#__PURE__*/(
      _jsx(Suspense, {
        fallback: /*#__PURE__*/
        _jsx("div", {}, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Loading"), "..."
        ) }, void 0, /*#__PURE__*/


      _jsx("div", { className: "row" }, void 0,
      !parsedPageError && /*#__PURE__*/
      React.createElement(React.Fragment, null,
      setBrowserTitle && /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, page.get('title') ? page.get('title') : 'Page')
      ), /*#__PURE__*/

      _jsx("main", { className: "page-viewer document-viewer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "main-wrapper" }, void 0,
      this.state.customPageError && this.renderErrorWarning(), /*#__PURE__*/
      _jsx(Context.Provider, { value: datasets }, void 0, /*#__PURE__*/
      _jsx(ErrorBoundary, {}, void 0, /*#__PURE__*/
      _jsx(MarkdownViewer, { html: true, markdown: originalText, lists: lists })
      )
      ), /*#__PURE__*/
      _jsx(Footer, {})
      )
      ), /*#__PURE__*/
      _jsx(Script, { scriptRendered: scriptRendered, onError: (e) => this.warningPageError(e) }, void 0,
      scriptCode
      )
      ),

      parsedPageError && /*#__PURE__*/
      _jsx("div", { className: "main-wrapper" }, void 0, /*#__PURE__*/
      _jsx(ErrorFallback, { error: parsedPageError }), /*#__PURE__*/
      _jsx(Footer, {})
      )

      )
      ));

  }
}

PageViewer.defaultProps = {
  page: Immutable.fromJS({}),
  itemLists: Immutable.fromJS([]),
  datasets: Immutable.fromJS({}),
  error: Immutable.fromJS({}),
  setBrowserTitle: true
};









const mapStateToProps = ({ page }) => ({
  page: page.pageView,
  datasets: page.datasets,
  itemLists: page.itemLists,
  error: page.error
});

const container = connect(mapStateToProps)(PageViewer);

export { container as PageViewer };